import React, { useEffect, useState } from 'react'

import {
  BorderStyle,
  Box,
  Color,
  Display,
  FlexDirection,
  AlignItems,
  Space,
} from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { basketNumPortionChange, portionSizeSelectedTracking } from 'actions/basket'
import { menuLoadBoxPrices } from 'actions/menu'
import { completeWizardBoxSize } from 'actions/trackingKeys'
import { NumberOfPortions } from 'routes/Menu/domains/basket'
import { trackSignupWizardAction } from 'routes/Signup/signupActions'
import { signupConfig } from 'routes/Signup/signupConfig'

import { PrimaryButton } from '../../Steps/BoxSize/PrimaryButton'
import { BoxSizePriceBreakdownAccordion } from '../BoxSizePriceBreakdownAccordion'
import { BoxSizePriceBreakdownInfo } from './BoxSizePriceBreakdownInfo'

type BoxSizePriceBreakdownBlockProps = {
  next: () => void
}

export const BoxSizePriceBreakdownBlock = ({ next }: BoxSizePriceBreakdownBlockProps) => {
  const { boxSizeTypes } = signupConfig.boxSizePriceBreakdownStep
  const [isOpen, setIsOpen] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(menuLoadBoxPrices())
  }, [dispatch])

  const handleClick = (value: NumberOfPortions) => {
    dispatch(portionSizeSelectedTracking(value))
    dispatch(basketNumPortionChange(value, isOpen))
    dispatch(
      trackSignupWizardAction(completeWizardBoxSize, {
        box_size: value,
      }),
    )
    next()
  }

  const renderBoxTypes = () =>
    boxSizeTypes.map(({ heading, subHeading, ctaText, value: boxSize }) => (
      <Box
        key={`box-size-for${boxSize}`}
        data-testid={`boxSizeFor${boxSize}`}
        borderStyle={BorderStyle.Solid}
        borderColor={Color.ColdGrey_200}
        borderWidth={0.5}
        borderRadius={1.5}
        paddingV={6}
        minWidth="16rem"
        width={['100%', null, 'auto']}
        flexGrow={1}
      >
        <BoxSizePriceBreakdownInfo heading={heading} subHeading={subHeading} boxSize={boxSize} />
        <BoxSizePriceBreakdownAccordion boxSize={boxSize} setIsOpen={setIsOpen} />
        <Space size={3} direction="vertical" />
        <Box paddingH={6}>
          <PrimaryButton value={boxSize} ctaText={ctaText} onPrimaryButtonClick={handleClick} />
        </Box>
      </Box>
    ))

  return (
    <Box
      display={Display.Flex}
      flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
      alignItems={AlignItems.FlexStart}
      gap={[6, 6, 4]}
    >
      {renderBoxTypes()}
    </Box>
  )
}
